import { render, staticRenderFns } from "./ClinicApiKeys.vue?vue&type=template&id=4eafabb7"
import script from "./ClinicApiKeys.vue?vue&type=script&lang=js"
export * from "./ClinicApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports